import { render, staticRenderFns } from "./XingbieBili.vue?vue&type=template&id=a0a4e122&scoped=true&"
import script from "./XingbieBili.vue?vue&type=script&lang=js&"
export * from "./XingbieBili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a4e122",
  null
  
)

export default component.exports